




































































































































































import { DateRange } from 'inscreva-sse-models';
import moment from 'moment';
import DatePicker, { DatePickerType } from 'ss-commons-front/src/components/DatePicker.vue';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop } from 'vue-property-decorator';

export type TimelineInterval = 'event' | 'subscription' | 'defaultInterval';
export interface Timeline {
  name?: string;
  group: TimelineInterval;
  onlyHour?: boolean;
  type: DatePickerType;
  dates: [string, string];
  showTimeRangePanel?: boolean;
  range?: boolean;
  selectable?: () => boolean;
  disabledDate?: (date: Date, dateChanged: number) => boolean;
  disabledTime?: (date: Date, dateChanged: number) => boolean;
}

export type FullHour = { hour: string; minute: string };

@Component({
  components: {
    DatePicker,
  },
})
export default class TimelinesComponent extends Vue {
  @Prop({ required: true })
  private readonly timelines: Array<Timeline>;

  $refs!: {
    validationTimeline: InstanceType<typeof ValidationProvider>;
  };

  private datePickers: Array<{ element: DatePicker; identifier: string }>;

  get is_completed() {
    return this.timelines.every(({ dates }) => dates.every((date) => !!date));
  }

  getTimelineStepName(timeline: Timeline, index: number) {
    return index === 0 ? 'Início' : index + 1 === timeline.dates.length ? 'Fim' : '...';
  }

  getHourAndMinute(value: string): FullHour {
    const regex = /^.*?T(\d{2}):?(\d{2})?.*?$/;
    const hour = (value: string) => value.replace(regex, '$1');
    const minute = (value: string) => value.replace(regex, '$2') || '00';
    return {
      hour: hour(value),
      minute: minute(value),
    };
  }

  getFullHour(value: string): string {
    if (!value) {
      return '';
    }
    const { hour, minute } = this.getHourAndMinute(value);
    return `${hour}:${minute}`;
  }

  getDateRange(dates: [string, string]): DateRange {
    return {
      start: dates[0] && new Date(dates[0]).toISOString(),
      end: dates[1] && new Date(dates[1]).toISOString(),
    };
  }

  getButtonTimelineName({ showTimeRangePanel }: Timeline) {
    return showTimeRangePanel === null
      ? 'Selecionar dias'
      : showTimeRangePanel === true
      ? 'Fechar'
      : 'Selecionar horário';
  }

  getFormattedDate(timeline: Timeline, date: string) {
    return (date && moment(date).format(`${!timeline.onlyHour ? 'DD/MM/YYYY' : ''} HH:mm`)) || '';
  }

  getRef<T>(identifier: string): T {
    return this.$refs[identifier] && this.$refs[identifier][0];
  }

  async mounted() {
    await this.validate();
    this.datePickers = this.timelines.map(({ group }) => ({
      element: this.getRef<DatePicker>(`datePicker${group}`),
      identifier: group,
    }));
    this.timelines.forEach(({ dates }, timelineIndex) =>
      dates.forEach(
        (date, dateIndex) =>
          (this.getRef<HTMLInputElement>(`dateInput_${timelineIndex}_${dateIndex}`).value = this.getFullHour(date)),
      ),
    );
  }

  async validate() {
    if (this.is_completed && this.$refs.validationTimeline) {
      await this.$refs.validationTimeline.validate(true);
    }
  }

  async updateTimeline(timeline: Timeline, timelineIndex: number) {
    await this.validate();
    this.$emit('on-update', { timeline, index: timelineIndex, date: this.getDateRange(timeline.dates) });
  }

  async toggleTimeRangePanel(timelineIndex: number) {
    const timeline = this.timelines[timelineIndex];
    Object.assign(timeline, { showTimeRangePanel: !timeline.showTimeRangePanel });
    const datePicker = this.datePickers.find((datePicker, idx) => idx === timelineIndex);
    if (timeline.showTimeRangePanel === false && datePicker?.element) {
      datePicker.element.close();
    }
    return this.updateTimeline(timeline, timelineIndex);
  }

  async handleRangeClose(timelineIndex: number) {
    const timeline = this.timelines[timelineIndex];
    Object.assign(timeline, { showTimeRangePanel: !timeline.showTimeRangePanel });
    return this.updateTimeline(timeline, timelineIndex);
  }

  async changeDate(date: string, timelineIndex: number, dateIndex: number) {
    const timeline = this.timelines[timelineIndex];
    timeline.dates.splice(dateIndex, 1, new Date(date).toISOString());
    return this.updateTimeline(timeline, timelineIndex);
  }

  async changeHour(event: any, timelineIndex: number, dateIndex: number) {
    const { value } = event.target;
    const date = new Date(this.timelines[timelineIndex].dates[dateIndex] || null);
    const { hour, minute } = this.getHourAndMinute(`T${value}`) as FullHour;
    const newHour = Number(hour) - 3;
    const newMinutes = Number(minute);
    date.setHours(newHour > 0 ? (newHour < 24 ? newHour : 23) : 0);
    date.setMinutes(newMinutes > 0 ? (newMinutes < 60 ? newMinutes : 59) : 0);
    const timeline = this.timelines[timelineIndex];
    timeline.dates.splice(dateIndex, 1, date.toISOString());
    return this.updateTimeline(timeline, timelineIndex);
  }
}
